import { Component } from '@angular/core';
import {NavBarComponent} from "../nav-bar/nav-bar.component";
import {HeroPromotionsComponent} from "./hero-promotions/hero-promotions.component";
import {PromotionsListComponent} from "./promotions-list/promotions-list.component";
import {FooterComponent} from "../../footer/footer.component";
import {FloatButtonComponent} from "../../float-button/float-button.component";
import {FooterPersonaComponent} from "../footer-persona/footer-persona.component";
import {TopBarComponent} from "../../top-bar/top-bar.component";

@Component({
  selector: 'app-promotions-person',
  standalone: true,
  imports: [
    NavBarComponent,
    HeroPromotionsComponent,
    PromotionsListComponent,
    FooterComponent,
    FloatButtonComponent,
    FooterPersonaComponent,
    TopBarComponent
  ],
  templateUrl: './promotions-person.component.html',
  styleUrl: './promotions-person.component.css'
})
export class PromotionsPersonComponent {

}
